import React, {useEffect, useRef, useState} from 'react';
import {UsePermissions} from "../../hooks/usePermissions";

import {Navigate} from "react-router";
import {ContainerTitleTable} from "../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../components/Containers/ContainerTable";
import {UseLoader} from "../../hooks/useLoader";
import {getdataAsociadoDeduccion} from "../../api/asociadoDeduccion.service";
import {Button} from "primereact/button";
import {TablaAsociadoDeduccion} from "./components/TablaAsociadoDeduccion";
import {ModalEditarAsociadoDeduccion} from "./components/ModalEditarAsociadoDeduccion";
import {ModalNuevoAsociadoDeduccion} from "./components/ModalNuevoAsociadoDeduccion";

export const AsociadoDeduccionPage = () => {
    const [field, setField] = useState({});
    const toast = useRef(null);
    const [permisos] = UsePermissions();
    const [handleLoad] = UseLoader();
    const [dataDeduccionAsociado, setDataDeduccionAsociado] = useState([]);
    const [displayeditModal, setDisplayeditModal] = useState(false);
    const [displayNewModal, setDisplayNewModal] = useState(false);
    const [fieldEdit, setFieldEdit] = useState({});
    const [reload, setReload] = useState(false);

    const dataAsociadoDeduccion = async () => {
        //e.preventDefault();
        try {
            handleLoad(true);
            const response = await getdataAsociadoDeduccion(field);
            handleLoad(false);
            if (response.estado !== 200) {
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                return;
            }
            setDataDeduccionAsociado(response.data);

        } catch (e) {
            handleLoad(false);
            console.log(e)
        }
    }

    const crearnuevoUsuario = () => {
        setDisplayNewModal(true);
    }

    const editarUsuario= (e) => {
        setFieldEdit({...e});
        setDisplayeditModal(true);
    }

    const onHide = () => {
        setDisplayNewModal(false);
        setReload(true);
        resetLoad();
    }

    const onHideEdit = () => {
        setDisplayeditModal(false);
        setReload(true);
        resetLoad()
    }

    const resetLoad = () => {
        setTimeout(() =>{
            setReload(false);
        }, 2000)
    }


    return(
      <div className="container-relative">
          <ContainerTitleTable>
              {permisos.submenu}
          </ContainerTitleTable>
          <ContainerTable>
              <div className="px-2">
                  <Button onClick={dataAsociadoDeduccion}>
                      Cargar Data
                  </Button>
                  <TablaAsociadoDeduccion
                      dataDeducciones={dataDeduccionAsociado}
                      reload={reload}
                      obtenerParametros={editarUsuario}
                      nuevoUsuario={crearnuevoUsuario}
                  />
              </div>
          </ContainerTable>
          <ModalNuevoAsociadoDeduccion show={displayNewModal} hide={onHide} />
          <ModalEditarAsociadoDeduccion show={displayeditModal} hide={onHideEdit} asoDedu={fieldEdit}/>
      </div>
  )
}
